import * as React from 'react';
import { FaRegCopy } from 'react-icons/fa';

import { ToolTipItem, NotificationHandler } from '@Components';
import './user-name.scss';

type UserNameProps = {
	name: string;
	email?: string;
	roles?: string[];
};

const TARGET_ID = 'nav-user-name';

export class UserName extends React.Component<UserNameProps> {
	render() {
		const { name } = this.props;
		return (
			<>
				<span id={TARGET_ID} className="user-name">Hello, {name}</span>
				<ToolTipItem targetId={TARGET_ID} className="user-tooltip" placement="bottom" text={this._tooltipContent()} />
			</>
		);
	}

	private _roleNames(): string {
		return (this.props.roles ?? []).map(role => role.replace('CrewPage.', '')).join(', ');
	}

	private _tooltipContent() {
		const { email } = this.props;
		const roleNames = this._roleNames();

		return (
			<>
				<div>{email || 'Unknown email'}</div>
				{roleNames && <div>
					{roleNames}
					<FaRegCopy className="user-tooltip-copy" title="Copy roles" onClick={this._copyRoles} />
				</div>}
			</>
		);
	}

	private _copyRoles = () => {
		const roleNames = this._roleNames();
		navigator.clipboard.writeText(roleNames)
			.then(() => NotificationHandler.showSuccess(`Roles copied: ${roleNames}`, 'Copy user roles'))
			.catch(err => NotificationHandler.showError(`Oops, unable to copy: ${err}`));
	};
}
